import { render, staticRenderFns } from "./PaymentSwiftTopUpCancelModal.vue?vue&type=template&id=5fc72ecf"
import script from "./PaymentSwiftTopUpCancelModal.vue?vue&type=script&lang=js"
export * from "./PaymentSwiftTopUpCancelModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentSwiftTopUpCancelModal.vue?vue&type=style&index=0&id=5fc72ecf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports